import { render, staticRenderFns } from "./swiper.vue?vue&type=template&id=70e81520&scoped=true"
import script from "./swiper.vue?vue&type=script&lang=ts"
export * from "./swiper.vue?vue&type=script&lang=ts"
import style0 from "./swiper.vue?vue&type=style&index=0&id=70e81520&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e81520",
  null
  
)

export default component.exports